module.exports = __webpack_public_path__ + "static/media/profile.f6eb8d67.svg";